import { render } from "./VendingMachinesModule.vue?vue&type=template&id=8a935a04&scoped=true"
import script from "./VendingMachinesModule.vue?vue&type=script&lang=js"
export * from "./VendingMachinesModule.vue?vue&type=script&lang=js"

import "./VendingMachinesModule.vue?vue&type=style&index=0&id=8a935a04&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8a935a04"

export default script